var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.855,
    height: 26.271,
    viewBox: "0 0 23.855 26.271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "playstore",
    transform: "translate(-23.549 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(23.549 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M65.121,9.023c-3.052-1.707-7.95-4.448-15.548-8.7A1.832,1.832,0,0,0,47.962.11L61,13.146Z",
    transform: "translate(-46.709 -0.012)",
    fill: "#32bbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M24.8,1.93a1.873,1.873,0,0,0-.277.118,1.833,1.833,0,0,0-.976,1.63V26.253a1.833,1.833,0,0,0,.976,1.63A1.9,1.9,0,0,0,24.8,28L37.837,14.966Z",
    transform: "translate(-23.549 -1.832)",
    fill: "#32bbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M60.992,255.98,47.956,269.016a1.813,1.813,0,0,0,1.611-.211c7.368-4.126,12.211-6.834,15.3-8.556l.253-.142Z",
    transform: "translate(-46.704 -242.846)",
    fill: "#32bbff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M23.549,255.98v11.287a1.833,1.833,0,0,0,.976,1.63,1.9,1.9,0,0,0,.277.119L37.837,255.98Z",
    transform: "translate(0 -242.845)",
    fill: "#2c9fd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M44.449.309A1.838,1.838,0,0,0,42.561.218L55.676,13.332,60,9.011C56.945,7.3,52.047,4.564,44.449.309Z",
    transform: "translate(-18.036 0)",
    fill: "#29cc5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M55.676,252.126,42.561,265.241a1.825,1.825,0,0,0,1.888-.092c7.368-4.126,12.211-6.834,15.3-8.556l.253-.142Z",
    transform: "translate(-18.036 -239.189)",
    fill: "#d93f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M304.265,177.122a1.828,1.828,0,0,0-.941-1.607s-1.17-.653-4.756-2.658l-4.265,4.265,4.269,4.269c3.546-1.991,4.751-2.663,4.751-2.663A1.828,1.828,0,0,0,304.265,177.122Z",
    transform: "translate(-256.861 -163.987)",
    fill: "#ffd500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M303.324,257.587a1.828,1.828,0,0,0,.941-1.607H294.3l4.269,4.269C302.119,258.258,303.324,257.587,303.324,257.587Z",
    transform: "translate(-256.861 -242.845)",
    fill: "#fa0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.62d6c2438ee4682a5a42bce776c6c901.svg";
export { ForwardRef as ReactComponent };